import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();
// Même mise en forme que TreesController.AddEssence : guillemets retirés, casse ignorée
const clean = (value) => (value || '').replace(/['"‘’“”`]/g, '').trim().toLowerCase();
const sameEssence = (a, b) => clean(a.gender) === clean(b.gender) && clean(a.species) === clean(b.species) && clean(a.cultivar) === clean(b.cultivar);

export const essenceHandlers = {
    'essence.create': {
        describe: op => i18n.t("Ajout de l'essence {{name}}", { name: [op.payload.essence.gender, op.payload.essence.species, op.payload.essence.cultivar].filter(Boolean).join(' ') }),
        // Une essence identique a pu être ajoutée entre-temps ; un ancien nom (absent de la liste) est résolu par l'API, qui renvoie
        // alors l'essence correspondante au lieu de la créer
        buildRequest: async (op, context) => {
            const existing = await context.request({ method: 'get', url: `${BACKEND_ENDPOINT}trees/essences` });
            const match = (existing.data || []).find(essence => sameEssence(essence, op.payload.essence));
            if (match) {
                await context.idMap.set('essence', op.target.id, match.id);
                return { discard: true, reason: 'already_exists' };
            }
            return { request: { method: 'post', url: `${BACKEND_ENDPOINT}trees/essences/`, data: op.payload.essence } };
        },
        onSuccess: async (op, response, context) => {
            const essences = Array.isArray(response.data) ? response.data : [];
            if (essences[0]) await context.idMap.set('essence', op.target.id, essences[0].id);
            return { essences, localId: op.target.id };
        }
    }
};
